import MyTeamLeaveBenefitComponent from "../components/MyTeamLeaveBenefit";
import useMyTeamLeaveBenefit from "../hooks/useMyTeamLeaveBenefit";

function MyTeamLeaveBenefit() {
  const useMyTeamLeaveBenefitProps = useMyTeamLeaveBenefit();
  return <MyTeamLeaveBenefitComponent {...useMyTeamLeaveBenefitProps} />;
}

export default MyTeamLeaveBenefit;
